import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, lastValueFrom, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AssetPreGenerateService {
  cache: Map<string, true | Promise<object>> = new Map();
  private http = inject(HttpClient);

  private isBase(url: string) {
    return url.includes('/base/') || url.includes('-base');
  }

  async preloadAsset(url: string) {
    if (!url) return;
    if (url.startsWith('data:')) return;
    if (this.isBase(url)) {
      // If the URL is a base URL, we don't need to pre-generate it
      return;
    }
    if (this.cache.has(url)) return;
    const promise = lastValueFrom(this.http.head(url + '?gen=true').pipe(catchError(() => of(undefined)))); // gen=true is a hack to bypass the browser cache (when the asset is loaded before the pre gen head request), which can cause cors errors
    this.cache.set(url, promise);
    await this.whenNotGenerating(url);
    this.cache.set(url, true);
  }

  async whenNotGenerating(url: string) {
    if (!this.cache.has(url)) return;
    const value = this.cache.get(url);
    if (value === true) return;
    await value;
    return true;
  }
}
